import { Text } from '@chakra-ui/react'
import { CatalogoBasePage, type ColumnConfig, type FieldConfig } from '../../../components/CatalogoBasePage'
import { componentTiersService } from '../../../api/services'
import type { ComponentTierItem } from '../../../api/models/maestros.models'
import { themeColors } from '../../../theme'

const columns: ColumnConfig<ComponentTierItem>[] = [
  { header: 'Código', render: (c) => <Text fontFamily="monospace" fontSize="sm" fontWeight="600" color={themeColors.text}>{c.code}</Text> },
  { header: 'Nombre', render: (c) => <Text fontSize="sm" color={themeColors.text}>{c.name}</Text> },
  { header: 'Descripción', render: (c) => <Text fontSize="sm" color={themeColors.textSecondary}>{c.description ?? '-'}</Text> },
  { header: 'Orden', render: (c) => <Text fontSize="sm" color={themeColors.textSecondary}>{c.sortOrder}</Text> },
]

const fields: FieldConfig<ComponentTierItem>[] = [
  { name: 'code', label: 'Código', type: 'text', required: true, placeholder: 'ej. principal' },
  { name: 'name', label: 'Nombre', type: 'text', required: true, placeholder: 'ej. Principal' },
  { name: 'description', label: 'Descripción', type: 'textarea', colSpan: 2 },
  { name: 'sortOrder', label: 'Orden', type: 'number', min: 0, step: 1 },
]

export default function ComponentTiersPage() {
  return (
    <CatalogoBasePage<ComponentTierItem>
      title="Niveles de Componente"
      subtitle="Clasifican los tipos de componente por criticidad dentro de la actividad (principal vs. secundario)."
      entityName="nivel de componente"
      service={componentTiersService as never}
      columns={columns}
      fields={fields}
      keyExtractor={(c) => c.id}
      idExtractor={(c) => c.id}
      searchPlaceholder="Buscar por código o nombre..."
      defaultValues={{ sortOrder: 99 }}
      createPermission="masters.write"
      updatePermission="masters.write"
      deletePermission="masters.write"
    />
  )
}
